module.exports = __webpack_public_path__ + "img/wheel-green.cbe10c24.png";